// extracted by mini-css-extract-plugin
export default {"codeBlock":"how-to-use-code-block_codeBlock__lUiEp","copyButton":"how-to-use-code-block_copyButton__Dp1Ji","copy":"how-to-use-code-block_copy__V8odw"};